import { getType } from '../helper/getType';

/**
 * @description 判断对象是不是有效对象
 * @description 当元素是对象，且内部至少一个属性时，即为有效数组
 * @returns boolean
 * @example
 *      var a = null // isEffectObject(a) => false
 *      var a = {} // isEffectObject(a) => false
 *      var a = {b:111} // isEffectObject(a) => true
 */
export function isEffectObject(param: any): boolean {
  if (param && getType(param) === 'object' && Object.keys(param)?.length > 0) {
    return true;
  }
  return false;
}
